import cabri from "../app/cabri-app";
import {GeomRelation} from "./geom-relation";

class FreePointOnLine extends GeomRelation {

    constructor (line, point) {
        if (arguments.length === 2) {
            super(
                cabri.emsc.createPointOnLineRel(line.objectId, point.objectId));
        }
        else {
            super(line);
        }
    }

}
export {FreePointOnLine}